var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"float":"right"},attrs:{"size":"mini","type":"success","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-arrow-to-left"}),_vm._v("  "+_vm._s(_vm.$t('use'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }